import store from 'store/Store';
import actions from 'Actions';
import samplesApi from 'services/api/samples';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import productSamplesActions from 'actions/ProductSamplesActions';
import userUtils from 'utils/User';

const SampleProductUtils = {
    openSamplesModal: function (mainProductSample) {
        if (Sephora.configurationSettings.isPDPSamplingEnabled && mainProductSample) {
            // We want the user to have to login before seeing the samples modal -SMPLS-960
            if (userUtils.isAnonymous()) {
                store.dispatch(
                    actions.showSignInModal({
                        isOpen: true,
                        callback: () => {
                            // After successful login, proceed to open the samples modal
                            this.openSamplesModalForAuthenticatedUser(mainProductSample);
                        },
                        errback: () => {
                            // User dismissed the login modal, oka then just do nothing
                            return;
                        }
                    })
                );

                return;
            }

            // User is authenticated, go on with the normal flow
            this.openSamplesModalForAuthenticatedUser(mainProductSample);
        }
    },

    openSamplesModalForAuthenticatedUser: function (mainProductSample) {
        if (Sephora.configurationSettings.isPDPSamplingEnabled && mainProductSample) {
            store.dispatch(actions.showInterstice(true));
            samplesApi
                .getProductSamples(mainProductSample.productId)
                .then(data => {
                    // Set the current produuct id in local storage so that if the user navigates to another page
                    // without closing the modal, and comes back to PDP, the modal will open automatically as requested
                    // in SMPLS-39
                    Storage.local.setItem(LOCAL_STORAGE.PDP_SAMPLES_MODAL, mainProductSample);
                    store.dispatch(
                        actions.showProductSamplesModal({
                            isOpen: true,
                            samples: data.productSampleSku || [],
                            mainProductSample: mainProductSample
                        })
                    );
                })
                .catch(() => {
                    store.dispatch(productSamplesActions.showErrorMessage());
                })
                .finally(() => {
                    store.dispatch(actions.showInterstice(false));
                });
        }
    }
};

export default SampleProductUtils;
